import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedDate, FormattedTime, FormattedMessage } from 'react-intl';
import messages from './messages';
import Header from '../../components/Header';

import './styles.css';

const DateTimeAgenda = ({ event }) => {
  const { type, pendingStatus, start, end, timezone } = event;
  const styleName = pendingStatus ? 'cal-date-time pending' : `cal-date-time ${type}`;
  let message = '';

  if (type === 'virtual') {
    message = messages.schoolVirtualVisit;
  } else if (type === 'fair') {
    message = messages.collegeFair;
  } else {
    message = messages.schoolPersonalVisit;
  }
  return (
    <div styleName={styleName} className={styleName}>
      <div styleName="date-time-text">
        <div styleName="date-text">
          <Header.Subheader as="h5">
            <FormattedDate
              value={start}
              weekday="long"
              month="long"
              day="numeric"
              year="numeric"
            />
          </Header.Subheader>
        </div>
        <div styleName="time-text">
          <FormattedTime value={start} />-<FormattedTime value={end} /> <span> ({timezone})</span>
        </div>
        <div styleName="sub-title">
          <FormattedMessage {...message} />
        </div>
      </div>
    </div>
  );
};

DateTimeAgenda.propTypes = {
  event: PropTypes.object,
};

export default injectIntl(DateTimeAgenda);
